import { putCurationOrder } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import {
  type UpdateCurationsOrderRequest,
  UpdateCurationsOrderRequestSchema,
  type UpdateCurationsOrderResponse,
  UpdateCurationsOrderResponseSchema,
} from './update-curations-order.dto';

export const updateCurationsOrderService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(UpdateCurationsOrderRequestSchema),
    async (request: UpdateCurationsOrderRequest): Promise<UpdateCurationsOrderResponse> => {
      const response = await putCurationOrder(request);

      if (response.meta?.result === 'FAIL') {
        throw new Error(response.meta?.message ?? '큐레이션 목록 순서 변경에 실패했습니다.');
      }

      return {
        success: true,
      };
    },
    validateServiceResponse(UpdateCurationsOrderResponseSchema),
  ),
);
